import XMLHttpRequestEventTarget from './XMLHttpRequestEventTarget.js';

/**
 * References: https://xhr.spec.whatwg.org/#xmlhttprequestupload.
 */
export default class XMLHttpRequestUpload extends XMLHttpRequestEventTarget {}
